import type { KonvaEventObject } from "konva/lib/Node";

import { AnnotationStrategy } from "./AnnotationStrategy";
import { useAnnotationStore } from "../store/annotationStore";
import { createPointAnnotation } from "../store/annotationTypes";
import { NORMALIZED_BOUNDS } from "../utils/coordinates";

export class PointAnnotationStrategy extends AnnotationStrategy {
  getAnnotationType(): string {
    return "point";
  }

  handlePointerDown(e: KonvaEventObject<PointerEvent>): void {
    const stage = e.target.getStage();
    const pointerPos = stage?.getPointerPosition();
    if (!pointerPos) return;

    const normalized = this.props.screenToNormalized(pointerPos.x, pointerPos.y);

    // Check if click is within image bounds
    if (
      normalized.x >= NORMALIZED_BOUNDS.MIN &&
      normalized.x <= NORMALIZED_BOUNDS.MAX &&
      normalized.y >= NORMALIZED_BOUNDS.MIN &&
      normalized.y <= NORMALIZED_BOUNDS.MAX
    ) {
      // For points, add immediately on click
      // Get current annotations from store for accurate count
      const currentAnnotations = useAnnotationStore.getState().getAnnotations();
      const pointCount = currentAnnotations.filter((a) => a.type === "point").length;
      this.props.addAnnotation(
        createPointAnnotation({
          x: normalized.x,
          y: normalized.y,
          label: `Point ${pointCount + 1}`,
        }),
      );
    }
  }

  handlePointerMove(_e: KonvaEventObject<PointerEvent>): void {
    // Points don't need move handling - they're placed on click
  }

  handlePointerUp(_e: KonvaEventObject<PointerEvent>): void {
    // Points are added on pointer down, nothing to do on up
  }
}
